import { AxiosResponse } from 'axios'

import { api } from '@/lib/axios'
import { MerchantType } from '@/types/merchant.types'

type MerchantDetailsType = {
  merchants: MerchantType[]
}

const getMerchant = (
  merchantId: string
): Promise<AxiosResponse<MerchantType>> => {
  return api.get<MerchantType>(`/merchants/${merchantId}`)
}

const getMerchants = (): Promise<AxiosResponse<MerchantDetailsType>> => {
  return api.get<MerchantDetailsType>('/merchants')
}

export default {
  getMerchant,
  getMerchants,
}
